import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

export const creditReducer = createSlice({
  name: "authentication",
  initialState: {
    credit: null,
  },
  reducers: {
    setCredit: (state, { payload }) => {
      state.credit = payload;
    },
  },
});

export const { setCredit } = creditReducer.actions;
export default creditReducer.reducer;

const header2 = {
  headers: {
    accept: "application/json; charset=UTF-8",
    "content-type": "text/plain",
    authorization: "Bearer " + localStorage.getItem("Token"),
  },
};

const getCredit = () => async (dispatch) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_API_OPERATOR}/api/memberMgmt/cusSite/memberBalance`,
      header2
    );
    // console.log(res);
    if (res.data.code == "999999") {
      await dispatch(setCredit(res.data.data));
    }
  } catch (err) {
    console.error(err);
  }
};

export { getCredit };
